export {version as default} from '../package.json';
